$(document).ready(function () {
	$(document).on('click', '.btn-set-threegift', function () {
		let id = $(this).data('id');
		let pricename = $(this).data('price_name');
		let did = $(this).closest('.discount-container').data('id');

		$.post(`/discounts/${did}/threegift/activate`, {
			id: id,
			price: pricename,
			_token: App.csrf,
		}, function (data) {
			$("#modal-threegift").modal('hide');
			if (data.redirect_to) {
				location.href = data.redirect_to
			} else {
				location.reload();
			}
		})

		return false;
	});
});
